import { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import TablePagination from "@mui/material/TablePagination";
import Typography from "@mui/material/Typography";
import PhotoLibraryOutlinedIcon from "@mui/icons-material/PhotoLibraryOutlined";
import { errorMessage } from "../../../util/ConfirmAlertUtil";
import { page } from "./api-mural-usuario";
import TablePaginationActions from "../../../shared/components/Table/Actions";
import Loading from "../../UI/Loading";
import MuralCardV2 from "../MuralCardV2";

const EMPTY_PAGE = { content: [], size: 0, number: 0, totalElements: 0 };

const MuralUsuarioContainer = () => {
  const [pageMuralUsuario, setPageMuralUsuario] = useState(EMPTY_PAGE);
  const [pageNumber, setPageNumber] = useState(0);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    let active = true;
    setIsLoading(true);
    page(pageNumber)
      .then((data) => {
        if (!active || !data) return;
        if (data.error) {
          errorMessage(data.message);
        } else {
          setPageMuralUsuario(data);
        }
      })
      .finally(() => {
        if (active) setIsLoading(false);
      });
    return () => {
      active = false;
    };
  }, [pageNumber]);

  const renderContent = () => {
    if (isLoading) {
      return (
        <Box py={5}>
          <Loading size={28} description="Carregando Mural de Fotos..." />
        </Box>
      );
    }
    if (pageMuralUsuario.content.length === 0) {
      return (
        <Box textAlign="center" color="text.secondary" py={5}>
          <PhotoLibraryOutlinedIcon fontSize="large" />
          <Typography variant="body2" mt={1}>
            Nenhum mural publicado.
          </Typography>
        </Box>
      );
    }
    return (
      <>
        <Box display="flex" flexWrap="wrap" gap={2} justifyContent={{ xs: "center", sm: "flex-start" }}>
          {pageMuralUsuario.content.map((muralUsuario) => (
            <MuralCardV2 key={muralUsuario.codigo} mural={muralUsuario.mural} />
          ))}
        </Box>
        <TablePagination
          rowsPerPageOptions={[]}
          rowsPerPage={pageMuralUsuario.size || 0}
          component="div"
          count={pageMuralUsuario.totalElements || 0}
          page={pageMuralUsuario.number || 0}
          onPageChange={(event, newPage) => setPageNumber(newPage)}
          labelDisplayedRows={({ from, to, count }) =>
            `${from}-${to} de ${count !== -1 ? `${count} registros` : `mais de ${to}`}`
          }
          ActionsComponent={TablePaginationActions}
        />
      </>
    );
  };

  return (
    <Paper variant="outlined" sx={{ borderRadius: 2, p: 2.5, height: "100%" }}>
      <Typography variant="subtitle1" fontWeight={600} mb={2}>
        Mural de Fotos
      </Typography>
      {renderContent()}
    </Paper>
  );
};

export default MuralUsuarioContainer;
